<template>
  <path
    d="M17 3.00018H7C5.9 3.00018 5 3.90018 5 5.00018V19.0002C5 20.1002 5.9 21.0002 7 21.0002H17C18.1 21.0002 19 20.1002 19 19.0002V5.00018C19 3.90018 18.1 3.00018 17 3.00018ZM16 19.0002H8C7.45 19.0002 7 18.5502 7 18.0002V6.00018C7 5.45018 7.45 5.00018 8 5.00018H16C16.55 5.00018 17 5.45018 17 6.00018V18.0002C17 18.5502 16.55 19.0002 16 19.0002Z"
  />
</template>
